const data = {
  topSection: {
    headingText: "Build your dream space with",
    highlightedText: "end-to-end solutions",
    headingText2: "that match your vision",
    subText: "Experience seamless construction and timely completion with Design Elementary",
    video: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fvideo.mp4?alt=media&token=be735ff7-2643-437f-90b7-5f7167174b04"
  },
  features: [

    {
      title: 'End-to-end project management',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fkey-features%2F1.png?alt=media&token=844e6d50-0038-4217-b786-7fa882fc83e2"
    },
    {
      title: 'Comprehensive planning and design',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fkey-features%2F2.png?alt=media&token=b734b252-82d7-410c-b2b6-4d3b067838fe"
    },
    {
      title: 'Cost estimation and budgeting',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fkey-features%2F3.png?alt=media&token=6d1a3d78-579f-43ea-865d-3559062bf33a"
    },
    {
      title: 'Material procurement and logistics',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fkey-features%2F4.png?alt=media&token=19db2ce1-a9a2-4e8a-ab2c-4167fce19c99"
    },
  ],

  numbers: [
    { number: 50, label: 'Interior Experts', symbol: '+', duration: 2500 },
    { number: 60, label: 'Location Served', symbol: '+', duration: 2500 },
    { number: 1000, label: 'Happy Clients', symbol: '+', duration: 2500 },
  ],

  stepsData: [
    {
      title: 'Project Briefing',
      description: 'Detailed discussion of project requirements.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F1.png?alt=media&token=22dd5952-7c2a-46ac-ae31-89703505c4b8"
    },
    {
      title: 'Design Development',
      description: 'Create comprehensive design plans.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F2.png?alt=media&token=897828ff-fbea-4a7d-91b1-e55a7c87d73a"
    },
    {
      title: 'Approval & Permits',
      description: 'Obtain necessary approvals and permits.',
      image:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F3.png?alt=media&token=f068564d-26c8-47d0-add9-3cbf7c4d9d56"
    },
    {
      title: 'Procurement',
      description: 'Source materials and contractors.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F4.png?alt=media&token=f46131e3-75c2-45dc-94d9-21043628f492"
    },
    {
      title: 'Construction',
      description: 'Manage full-scale construction process.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F5.png?alt=media&token=49d4555b-274e-47a7-b2ac-865a799dca48"
    },
    {
      title: 'Handover',
      description: 'Deliver completed project to client.',
      image: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F6.png?alt=media&token=91ef691c-d020-4d7c-a63f-22c8377a7234"
    },
  ],

  stepData: [
    {
      number:1,
      title: 'Project Briefing',
      description: 'Detailed discussion of project requirements.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F1.png?alt=media&token=22dd5952-7c2a-46ac-ae31-89703505c4b8"
    },
    {
      number:2,
      title: 'Design Development',
      description: 'Create comprehensive design plans.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F2.png?alt=media&token=897828ff-fbea-4a7d-91b1-e55a7c87d73a"
    },
    {
      number:3,
      title: 'Approval & Permits',
      description: 'Obtain necessary approvals and permits.',
      icon:"https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F3.png?alt=media&token=f068564d-26c8-47d0-add9-3cbf7c4d9d56"
    },
    {
      number:4,
      title: 'Procurement',
      description: 'Source materials and contractors.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F4.png?alt=media&token=f46131e3-75c2-45dc-94d9-21043628f492"
    },
    {
      number:5,
      title: 'Construction',
      description: 'Manage full-scale construction process.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F5.png?alt=media&token=49d4555b-274e-47a7-b2ac-865a799dca48"
    },
    {
      number:6,
      title: 'Handover',
      description: 'Deliver completed project to client.',
      icon: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Fother-services%2FTurnKey%2Fhow-it-works%2F6.png?alt=media&token=91ef691c-d020-4d7c-a63f-22c8377a7234"
    },
  ],

  faqs: [
    {
      question: 'What is a turnkey project?',
      answer:
        'A turnkey project is a complete solution where we handle every aspect, from design and planning to execution and final delivery, ensuring the project is ready for immediate use without managing individual tasks.',
    },
    {
      question: 'What are the benefits of opting for a turnkey project?',
      answer:
        'Turnkey projects offer a single point of contact, streamlined management, cost efficiency, reduced risks, timely completion, and convenience without managing multiple contractors or phases.',
    },
    {
      question: 'What industries can benefit from turnkey project services?',
      answer:
        'Industries like construction, real estate, hospitality, manufacturing, healthcare, IT, and retail can benefit from turnkey solutions, ideal for end-to-end project delivery.',
    },
    {
      question: 'What is included in a turnkey project?',
      answer:
        'A turnkey project includes planning, design, procurement, construction, installation, quality control, and delivery. We handle everything from start to finish, meeting specifications, timelines, and budgets.',
    },
    {
      question: 'How do you ensure quality control in turnkey projects?',
      answer:
        'We employ experienced professionals, use high-quality materials, follow industry standards, conduct regular inspections, ensure compliance with safety regulations, and provide updates throughout the project for transparency.',
    },
  ],

  reviews: [
    {
      review: "Outstanding design. They captured our vision with precision and efficiency. Highly satisfied!",
      name: "Mitali Sinha",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fmitali-sinha.jpeg?alt=media&token=9c952e12-04e5-454c-a2d7-3f8796706891",
      rating: 5
    },
    {
      review: "Transformed our space beautifully. A seamless process from start to finish. Highly recommended.",
      name: "P. Gowda",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fp-gowda.jpeg?alt=media&token=cd8de94e-73a2-4a14-92c7-7b1e3ae79d48",
      rating: 4
    },
    {
      review: "They listened, they delivered. Impressed by their service.",
      name: "Nitin Prajapat",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fnitin-prajapat.jpeg?alt=media&token=f783369b-6c53-4c80-82eb-8a86e89debef",
      rating: 4
    },
    {
      review: "Fantastic architecture design & affordable.",
      name: "Snehal Raj",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fsnehal-raj.jpeg?alt=media&token=8937fcad-9cff-4196-9bde-9b114eea6990",
      rating: 5
    },
  ],
  review: [
    {
      quote: "Outstanding design. They captured our vision with precision and efficiency. Highly satisfied!",
      name: "Mitali Sinha",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fmitali-sinha.jpeg?alt=media&token=9c952e12-04e5-454c-a2d7-3f8796706891",
      rating: 5
    },
    {
      quote: "Transformed our space beautifully. A seamless process from start to finish. Highly recommended.",
      name: "P. Gowda",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fp-gowda.jpeg?alt=media&token=cd8de94e-73a2-4a14-92c7-7b1e3ae79d48",
      rating: 4
    },
    {
      quote: "They listened, they delivered. Impressed by their service.",
      name: "Nitin Prajapat",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fnitin-prajapat.jpeg?alt=media&token=f783369b-6c53-4c80-82eb-8a86e89debef",
      rating: 4
    },
    {
      quote: "Fantastic architecture design & affordable.",
      name: "Snehal Raj",
      avatar: "https://firebasestorage.googleapis.com/v0/b/design-elementary-2.appspot.com/o/de%2Ftestimonials%2Fsnehal-raj.jpeg?alt=media&token=8937fcad-9cff-4196-9bde-9b114eea6990",
      rating: 5
    },
  ]
};

export default data;
